export enum LicenseWarningLevel {
  None = "none",
  Warning = "warning",
  Danger = "danger",
}
